module.exports = __webpack_public_path__ + "static/img/guide-30.19639f0f.png";